import React, { useState, useEffect } from "react";
import "./FAQ.css";
import faq1 from "../assets/oi_chat.png";
const mockFAQs = [
  {
    id: 1,
    question: "How long does visa processing take?",
    answer: "Standard processing typically takes 5-15 working days. Premium processing options are available for faster service."
  },
  {
    id: 2,
    question: "What documents do I need for a visa application?",
    answer: "Required documents include valid passport, photographs, bank statements, travel itinerary, and completed application form."
  },
  {
    id: 3,
    question: "What is the visa rejection rate?",
    answer: "Rejection rates vary by country and visa type, typically ranging from 5-15%. Common reasons include incomplete documentation or insufficient funds."
  },
  {
    id: 4,
    question: "Do you offer visa application assistance?",
    answer: "Yes, we provide end-to-end visa assistance including document verification, form filling, and application tracking."
  },
  {
    id: 5,
    question: "What are the payment options available?",
    answer: "We accept credit/debit cards, net banking, UPI, and EMI options for visa processing fees."
  },
  {
    id: 6,
    question: "Is travel insurance mandatory?",
    answer: "Yes, most countries require travel insurance covering medical emergencies and repatriation for the entire stay duration."
  },
  {
    id: 7,
    question: "Can I track my visa application status?",
    answer: "Yes, you'll receive a tracking number to monitor your application status through our online portal."
  },
  {
    id: 8,
    question: "What if my visa gets rejected?",
    answer: "We provide free consultation for reapplication and guide you through addressing the rejection reasons."
  }
];

const FAQ = () => {
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        const fetchFAQs = async () => {
            try {
                const response = await fetch('/api/faqs');
                if (!response.ok) throw new Error('Failed to fetch');
                const data = await response.json();
                setFaqs(data);
                // TODO: Remove in production
                console.log('FAQs fetched successfully');
            } catch (error) {
                // TODO: Remove in production
                console.log('Using mock data:', error);
                setFaqs(mockFAQs);
            }
        };

        fetchFAQs();
    }, []);

    return (
        <div className="faq-container">
            <div className="sectiontitle">Frequently Asked <span>Question</span></div>
            <div className="faq-list">
                {faqs.map((faq, index) => (
                    <div key={faq.id} className="faq-item">
                        <div className="sms-container">
                            <img src={faq1} alt="chat icon" />
                        </div>
                        <div className="faq-question">
                            {faq.question}
                        </div>
                        <div className="faq-answer">
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;